import { useLazyQuery, useMutation } from "@apollo/client";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { useEffect } from "react";

import { Button, getInput } from "../../../components/ui";
import { FETCH_EDITIONS_V2 as fetchEditionsV2 } from "../../../graphql/query/Edition";
import { UPDATE_INSTANCE as updateInstanceMutation } from "../../../graphql/mutation/Instance";

const ChangeEditionNumber = props => {
  const { closeModal, instance } = props || {};
  const navigate = useNavigate();
  const [updateInstance, { loading }] = useMutation(
    updateInstanceMutation(),
    {
      refetchQueries: ["FetchInstance", "FetchInstances", "FetchInstancesV2"],
    },
  );

  const artworkId = instance?.artworkId || instance?.edition?.artwork?.id;
  const editionId = instance?.editionId || instance?.edition?.id;

  const [fetchEditions, { data: { editionsV2 = [] } = {} }] = useLazyQuery(
    fetchEditionsV2({ artwork: false, number: true }),
    {
      variables: {
        input: {
          _artwork: {
            id: {
              operator: "eq",
              value: artworkId,
            },
          },
        },
      },
    },
  );

  useEffect(() => {
    if (artworkId) {
      fetchEditions();
    }
  }, [artworkId, fetchEditions]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { editionNumber: "" },
    validationSchema: Yup.object({}),
    onSubmit: async values => {
      updateInstance({
        variables: {
          input: {
            editionNumber: values?.editionNumber,
            id: instance?.id,
          },
        },
      }).then(resp => {
        const {
          data: { updateInstance: { success, instance } = {} },
        } = resp || {};
        if (success) {
          formik.resetForm();
          navigate(`/instance/${instance?.id}/details`);
          closeModal();
        }
      });
    },
  });

  const edition = editionsV2?.edges?.find(item => item?.id === editionId);
  const possibleNumbers = edition
    ? Array.from({ length: edition?.number || 0 }, (_, index) => {
        const value = index + 1;
        return { label: value, value };
      })
    : [];

  const inputs = [
    {
      label: "Edition",
      name: "editionId",
      type: "multi-select",
      options: editionsV2?.edges?.map(item => ({
        label: `Edition ${item?.id}`,
        value: item.id,
      })),
    },
    {
      label: "Edition Number",
      name: "editionNumber",
      type: "multi-select",
      options: possibleNumbers,
      disabled: possibleNumbers.length === 0,
      inputClassName:
        possibleNumbers.length === 0
          ? "!bg-white !text-gray-400 !border-gray-400"
          : "",
    },
  ];

  const hasErrors = Object.keys(formik?.errors || {}).length > 0;

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-row">
        <div className="flex flex-1 flex-col text-2xl font-bold">
          <div>Change edition number</div>
        </div>
        <div className="flex gap-4">
          <Button action="default" label="Cancel" onClick={closeModal} />
          <Button
            label={"Change"}
            loading={loading}
            disabled={loading || hasErrors}
            onClick={formik.submitForm}
          />
        </div>
      </div>
      <div className="w-50 grid grid-cols-1 md:grid-cols-2 gap-4">
        {inputs?.map((item, index) => {
          const inputProps = {
            ...item,
            formik,
          };
          return <div key={index}>{getInput(inputProps)}</div>;
        })}
      </div>
    </div>
  );
};

export default ChangeEditionNumber;
